'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import TemplateBuffer from 'DesignData/models/TemplateBuffer';
import { TEMPLATE_BUFFER_DELETE, TEMPLATE_REVISION_FETCH, TEMPLATE_REVISIONS_FETCH } from 'DesignData/actions/ActionTypes';
/**
 * revisions
 * Stores template revisions by revision id.
 */

function revisions(state = SeamlessImmutable({
  revisions: {}
}), action) {
  switch (action.type) {
    case TEMPLATE_REVISIONS_FETCH:
      {
        const {
          revisions: revs
        } = action;

        if (!revs) {
          return state;
        }

        revs.forEach(revision => {
          if (revision.id !== -1 && state.revisions[revision.id]) {
            // We've already downloaded this revision - it isn't going to change.
            return;
          }

          const model = new TemplateBuffer(revision.object);
          state = state.setIn(['revisions', revision.id], model);
        });
        return state;
      }

    case TEMPLATE_REVISION_FETCH:
      {
        const {
          template,
          revisionId
        } = action;

        if (!(template && revisionId)) {
          return state;
        }

        if (revisionId !== -1 && state.revisions[revisionId]) {
          // We've already downloaded this revision - it isn't going to change.
          return state;
        }

        const model = new TemplateBuffer(template);
        return state.setIn(['revisions', revisionId], model);
      }

    default:
      return state;
  }
}

function templates(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case TEMPLATE_REVISION_FETCH:
    case TEMPLATE_REVISIONS_FETCH:
      {
        const templateId = action.templateId || action.resourceId;
        return state.set(templateId, revisions(state[templateId], action));
      }

    case TEMPLATE_BUFFER_DELETE:
      {
        const {
          templateId,
          error
        } = action;

        if (error) {
          return state;
        }

        return state.without(templateId);
      }

    default:
      return state;
  }
}

export default combineReducers({
  templates
});